module.exports = __webpack_public_path__ + "img/CA4FE1_6B2398_A337C7_9334BC-256px.2bb63a08.png";